import React, { useState, useRef, useEffect, useContext } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import { useParams } from 'react-router-dom';
import { AppConfigContext } from '../../Config/App';
import { BuildContext } from '../../Data/Context/buildData';
import { LanguageContext } from '../../Data/Context/languageContext';
import { motion } from "framer-motion";

const CopyShare = () => {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const { viewingID, editingID } = useParams();
    const { site_url } = useContext(AppConfigContext);
    const { buildDataFromDB } = useContext(BuildContext);
    const { t } = useContext(LanguageContext);

    function copyLink() {
        navigator.clipboard.writeText(site_url('build/' + buildDataFromDB.build_id));
        setShow(!show);
    }

    useEffect(() => {
        setTimeout(() => {
            setShow(false);
        }, 2000);
    }, [show]);

    if (editingID || viewingID) {
        return (
            <>
                <motion.button whileTap={{ scale: 0.9 }} onClick={() => copyLink()} ref={target} className='btn btn-primary mx-2' type="button"><i className="fa-solid fa-share-nodes"></i> {t("copy_share")}</motion.button>
                <Overlay target={target.current} show={show} placement="top">
                    {(props) => (
                        <Tooltip id="overlay-example" {...props}>
                            {t("copied")}
                        </Tooltip>
                    )}
                </Overlay>
            </>
        );
    }
}
export default CopyShare;